module.exports = __webpack_public_path__ + "static/media/Somalia.61112a71.png";